(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["msds-sheets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('msds-sheets')) {
    customElements.define(
      'msds-sheets',
      class MsdsSheets extends HTMLElement {
        connectedCallback() {
          this.querySelector('.msds-sheets__search')?.addEventListener('input', this.#filter);
        }

        #filter = (event) => {
          const term = event.target.value.trim().toLowerCase();
          let visible = 0;

          for (const item of this.querySelectorAll('.msds-sheets__item')) {
            const match = item.dataset.title.includes(term);
            item.hidden = !match;
            if (match) visible++;
          }

          const noResults = this.querySelector('[data-no-results]');
          if (noResults) noResults.hidden = visible > 0;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
